import { action } from "satcheljs";

const restartImport = action(
    "restartImport", () => ({})
);

export default restartImport;